import React, { useState } from 'react';
import { Hero } from '../components/Hero';
import { Platforms } from '../components/Platforms';
import { ThoughtCards } from '../components/ThoughtCards';
import { ConversionExplanation } from '../components/ConversionExplanation';
import { Examples } from '../components/Examples';
import { FAQ } from '../components/FAQ';
import { CTASection } from '../components/CTASection';
import { LoadingState } from '../components/LoadingState';
import { CopyAnalysisTable } from '../components/CopyAnalysisTable';
import { CopyAnalysisResult } from '../types/copyAnalysis';

export function HomePage() {
  const [isAnalyzing, setIsAnalyzing] = useState(false);
  const [showHero, setShowHero] = useState(true);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [analysisResult, setAnalysisResult] = useState<CopyAnalysisResult | null>(null);

  const handleAnalysisStart = () => {
    setIsTransitioning(true);
    setTimeout(() => {
      setIsAnalyzing(true);
      setShowHero(false);
      setIsTransitioning(false);
    }, 500);
  };

  const handleAnalysisComplete = (result: CopyAnalysisResult | null) => {
    setIsTransitioning(true);
    setTimeout(() => {
      setIsAnalyzing(false);
      setAnalysisResult(result);
      setTimeout(() => {
        setIsTransitioning(false);
      }, 100);
    }, 500);
  };

  return (
    <div className="container mx-auto px-4">
      <div
        className={`transition-all duration-500 ease-in-out ${
          isTransitioning ? 'opacity-0 translate-y-10' : 'opacity-100 translate-y-0'
        }`}
      >
        {showHero ? (
          <>
            <Hero 
              onAnalysisStart={handleAnalysisStart} 
              onAnalysisComplete={handleAnalysisComplete}
            />
            <Platforms />
            <ThoughtCards />
            <ConversionExplanation />
            <Examples />
            <FAQ showAll={false} />
            <CTASection />
          </>
        ) : (
          <div className="pt-32">
            {isAnalyzing ? (
              <LoadingState />
            ) : (
              <div className="animate-fade-in">
                <CopyAnalysisTable analysis={analysisResult} />
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}